import React, { useState } from 'react'

import { Avatar, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string, oneOfType, number, func, oneOf } from 'prop-types'

import { useComments } from '../Hooks/useComments'
import { useCommentsContext } from '../Hooks/useCommentsContext'

function CommentsForm({
  isEditMode = false,
  defaultContent = '',
  commentId = null,
  submitCallback = null,
}) {
  const { userData, itemId } = useCommentsContext()
  const { currentUserId, currentUserUsername, currentUserAvatarUrl } =
    userData || {}

  const [currentComment, setCurrentComment] = useState(defaultContent)
  const { isRequesting, createComment, editComment } = useComments()

  function handleInputChange(e) {
    if (e.target) {
      const { value } = e.target

      setCurrentComment(value)
    }
  }

  function handleSubmit(e) {
    e.preventDefault()

    const authenticityToken = window.getToken()

    if (currentUserId && authenticityToken) {
      const defaultPayload = {
        token: authenticityToken,
        content: currentComment,
      }

      if (isEditMode && commentId && submitCallback) {
        editComment({
          ...defaultPayload,
          id: commentId,
        })
        setCurrentComment('')
        return submitCallback()
      }

      createComment({
        ...defaultPayload,
        id: itemId,
      })

      setCurrentComment('')
    }
  }

  const actionText = isEditMode ? 'Update comment' : 'Post comment'

  return (
    <div className="comment-form-container">
      <form onSubmit={handleSubmit} className="comment-form">
        {!isEditMode && (
          <div className="comment-form__author">
            <Avatar
              img={currentUserAvatarUrl}
              username={currentUserUsername}
              size="48"
            />
          </div>
        )}

        <div className="comment-form__content">
          <textarea
            onChange={handleInputChange}
            disabled={isRequesting}
            className="textarea"
            placeholder="Your comment"
            required
            value={currentComment}
          />

          <Button
            disabled={isRequesting}
            actionType="submit"
            size="small"
            customClass="js-auth-control"
          >
            {actionText}
          </Button>
        </div>
      </form>
    </div>
  )
}

CommentsForm.propTypes = {
  isEditMode: bool,
  defaultContent: string,
  commentId: oneOfType([number, oneOf([null])]),
  submitCallback: oneOfType([func, oneOf([null])]),
}

export default CommentsForm
